import routing from './report.route';
import run from './report.run';
import reportListCtrl from './list/reportListCtrl';
import powerbiWorkPlanCtrl from './reportWorkPlanPowerbi/powerbiWorkPlanCtrl'
import staticReportCtrl from './static/staticReportCtrl';
import reportSrv from './reportSrv';
import GlobalConfig from '../../../globals/globalConfig.json';
import reportModalCtrl from './modals/reportModalCtrl'

require('./dist/pivot.css');

require('./dist/pivot.js');

$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/1.11.2/jquery.min.js")

$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js")

$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js")

export default angular.module('report', [reportSrv])
.config(routing)
.controller('ReportListCtrl', reportListCtrl)
.controller('powerbiWorkPlanCtrl', powerbiWorkPlanCtrl)
.controller('StaticReportCtrl', staticReportCtrl)
.controller('reportModalCtrl', reportModalCtrl)
.run(run)
.constant("report", [{
	title: "Reportes",
	icon: "mdi-action-assignment-turned-in",
	// 'moduleId': GlobalConfig.menuModulesId.Reportes,
	 subMenu: [
	//  {
	//   	title: 'Reportes Globales',
	//   	url: "report.reportGlobal",
	// 		rolesAllowed: [
	// 			GlobalConfig.userRolesIds.teacher,
	// 			GlobalConfig.userRolesIds.workPlanAdmin,
	// 			GlobalConfig.userRolesIds.approver,
	// 			GlobalConfig.userRolesIds.reviewer,
	// 			GlobalConfig.userRolesIds.unitAdmin,
	// 			GlobalConfig.userRolesIds.gerencialConsultant,
	// 			GlobalConfig.userRolesIds.generalAdmin,
	// 		]
	// },
	{
		title: "Reportes Estáticos",
		url: "report.staticReport",
		rolesAllowed: [
			GlobalConfig.userRolesIds.teacher,
			GlobalConfig.userRolesIds.workPlanAdmin,
			GlobalConfig.userRolesIds.approver,
			GlobalConfig.userRolesIds.reviewer,
			GlobalConfig.userRolesIds.unitAdmin,
			GlobalConfig.userRolesIds.gerencialConsultant,
			GlobalConfig.userRolesIds.generalConsultant,
			GlobalConfig.userRolesIds.generalAdmin
		]
	},
	{
	  	title: 'Reportes Dinámicos',
	  	url: "report.reportList",
			rolesAllowed: [
				GlobalConfig.userRolesIds.teacher,
				GlobalConfig.userRolesIds.workPlanAdmin,
				GlobalConfig.userRolesIds.approver,
				GlobalConfig.userRolesIds.reviewer,
				GlobalConfig.userRolesIds.unitAdmin,
				GlobalConfig.userRolesIds.gerencialConsultant,
				GlobalConfig.userRolesIds.generalConsultant,
				GlobalConfig.userRolesIds.generalAdmin,
			]
	},
	{
		title: "Reporte Plan de Trabajo",
		url: "report.powerbiWorkPlan",
		rolesAllowed: [
			GlobalConfig.userRolesIds.teacher,
			GlobalConfig.userRolesIds.workPlanAdmin,
			GlobalConfig.userRolesIds.approver,
			GlobalConfig.userRolesIds.reviewer,
			GlobalConfig.userRolesIds.unitAdmin,
			GlobalConfig.userRolesIds.gerencialConsultant,
			GlobalConfig.userRolesIds.generalConsultant,
			GlobalConfig.userRolesIds.generalAdmin
		]
	},],
}])
.name;




// WEBPACK FOOTER //
// ./src/app/u-faculty/report/index.js